// removed by extract-text-webpack-plugin
module.exports = {"content":"purify_MainEngineNotStarted__content___CJrEX"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/shared/MainEngineNotStarted/MainEngineNotStarted.scss
// module id = 227
// module chunks = 0